export default __webpack_public_path__ + "static/media/sinergia.3a6d9692.png";